import registerTool from './register-tool';
import setActiveTool from './set-active-tool';

export default {
  registerTool,
  setActiveTool,
};
